import React from 'react';

const Button = ({
  children,
  variant = 'default',
  size = 'md',
  className = '',
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-lg';
  
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };

  const variantStyles = {
    default: `bg-gradient-to-r from-purple-500 to-pink-500 text-white 
              shadow-lg shadow-purple-500/25 hover:shadow-purple-500/40 
              hover:from-purple-600 hover:to-pink-600 
              active:from-purple-700 active:to-pink-700`,
              
    secondary: `bg-gradient-to-r from-gray-500/10 to-gray-600/10 text-gray-300
                backdrop-blur-sm border border-white/10
                hover:border-white/20 hover:from-gray-500/20 hover:to-gray-600/20
                active:from-gray-500/30 active:to-gray-600/30`,
                
    destructive: `bg-gradient-to-r from-red-500 to-orange-500 text-white 
                  shadow-lg shadow-red-500/25 hover:shadow-red-500/40
                  hover:from-red-600 hover:to-orange-600
                  active:from-red-700 active:to-orange-700`,
                  
    success: `bg-gradient-to-r from-green-500 to-emerald-500 text-white 
              shadow-lg shadow-green-500/25 hover:shadow-green-500/40
              hover:from-green-600 hover:to-emerald-600
              active:from-green-700 active:to-emerald-700`,
              
    ghost: `bg-gradient-to-r from-white/0 to-white/0 text-gray-300
            hover:from-white/5 hover:to-white/5
            active:from-white/10 active:to-white/10`,
            
    premium: `bg-gradient-to-r from-yellow-500 to-amber-500 text-white 
              shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40
              hover:from-yellow-600 hover:to-amber-600
              active:from-yellow-700 active:to-amber-700`,
  };

  const disabledStyles = props.disabled ? 
    'opacity-50 cursor-not-allowed pointer-events-none' : 
    'transform hover:scale-102 active:scale-98';

  return (
    <button
      className={`
        ${baseStyles}
        ${sizeStyles[size]}
        ${variantStyles[variant]}
        ${disabledStyles}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;